import { IApiAdQueryParams, IApiAdTargeting } from 'redux-state/advertisement/types.js';
import { useAppSelector } from 'redux-state/configure-store.js';
import { BuildDynamicQueryTargeting } from './targeting-dynamic.js';
import { buildAdTargeting } from './targetting-static.js';

/** Merges targeting if we want to apply site-wide settings or dynamic e.g. BBQ location */
export const AdvertFuseModuleTargetingHook = ({
  overrideBaseTargeting,
  mergeBaseTargeting,
  targeting,
  queryParams,
}: {
  overrideBaseTargeting: boolean;
  mergeBaseTargeting: boolean;
  queryParams?: IApiAdQueryParams[];
  targeting?: IApiAdTargeting[];
}) => {
  const baseTarget = useAppSelector((state) => state.ADVERTISEMENT.targeting) ?? [];
  const staticTargeting = buildAdTargeting({ overrideBaseTargeting, mergeBaseTargeting, targeting, baseTarget });
  /** Add dynamic targeting if needed */
  const dynamicTargeting = BuildDynamicQueryTargeting({ overrideBaseTargeting, queryParams });
  const finalTargeting = dynamicTargeting.length ? dynamicTargeting.concat(staticTargeting) : staticTargeting;

  return finalTargeting;
};
